// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 2.5H9.48062L11.4806 5H23V13.1878C21.8537 11.8487 20.151 11 18.25 11C14.7982 11 12 13.7982 12 17.25C12 18.657 12.4649 19.9554 13.2495 21H1V2.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 17.25C23 18.1992 22.7216 19.0834 22.2419 19.8254L23.9142 21.5017L22.4983 22.9142L20.8282 21.2401C20.0857 21.7209 19.2004 22 18.25 22C15.6266 22 13.5 19.8734 13.5 17.25C13.5 14.6266 15.6266 12.5 18.25 12.5C20.8734 12.5 23 14.6266 23 17.25ZM21 17.25C21 15.7312 19.7688 14.5 18.25 14.5C16.7312 14.5 15.5 15.7312 15.5 17.25C15.5 18.7688 16.7312 20 18.25 20C19.0061 20 19.6908 19.6949 20.188 19.2011L20.1963 19.1928C20.6929 18.6952 21 18.0085 21 17.25Z"}}]};

const FolderSearchFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'folder-search-filled',
    ref,
    icon: element,
  },
));

FolderSearchFilledIcon.displayName = 'FolderSearchFilledIcon';

export default FolderSearchFilledIcon;
